import { useState, useRef, useContext, useEffect, useCallback, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import getAgGridHeight from "../../../../utils/commonFunctions/getAgGridHeight";
import { CustomPagination } from "../../../shared";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { PaginationTypes } from "../../../../@types/pagination.types.js";
import { SnackbarProps } from "../../../../@types/snackbarAPI.types.js";
import { CustomImageDialog } from "../../../../@types/components/dialogProps.types.js";
import getLimit from "../../../../utils/pagination/getLimit";
import { AuthContext, UIContext } from "../../../../contexts";
import { api } from "../../../../utils/api";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import generateImageDialogLink from "../../../../utils/commonFunctions/generateImageDialogLink";
import { LazyCustomImageDialog, LazyCustomDialog, LazySnackbarAPI } from "../../../shared";
import { DialogProps } from "../../../../@types/dialogProps.types.js";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import "./healthLinks.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useEmployerRoute } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import generateImageUrl from "../../../../utils/commonFunctions/imageUrl";
import { trackPromise } from "react-promise-tracker";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { link } from "fs";
import { GROUP_NAME, GROUP_NUMBER } from "../../../../constants/groups";
import { getPermissionsFromGroupOwner } from "../../../../utils/getPermissionsFromGroupOwner";
// import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
// import generateImageDialogLink from "../../../../utils/commonFunctions/generateImageDialogLink";

const HealthLinks = () => {
	const [links, setLinks] = useState<any[]>([]);
	const [linkFilterSchema, setLinkFilterSchema] = useState({
		text: { value: null, type: null },
		URL: { value: null, type: null },
		category: { value: null, type: null },
		description: { value: null, type: null },
		date: { value: null, type: null }
	});
	const navigate = useNavigate();
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("400px");
	const [limit, setLimit] = useState<number>();
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: 11
	});
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");

	const { user, setUser } = useContext(AuthContext);

	// eslint-disable-next-line no-unused-vars
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const { setDashboardHeader } = useContext(UIContext);
	const agGridRef = useRef<any>(null);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	// eslint-disable-next-line no-unused-vars
	const [imageDialogProps, setImageDialogProps] = useState<CustomImageDialog>({
		openDialog: false,
		image: undefined,
		handleCloseCallback: () =>
			setImageDialogProps(
				Object.assign({}, imageDialogProps, {
					openDialog: false
				})
			)
	});
	const [deleteDialogProps, setDeleteDialogProps] = useState<DialogProps>({
		openDialog: false,
		title: "",
		content: "",
		actions: []
	});

	//useMediaQuery
	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");
	const _limit = getLimit(xl, lg, md, sm, xs);

	// Functions for Pagination
	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setPagination(
				Object.assign({}, pagination, {
					currentPage: page
				})
			);
		},
		[pagination]
	);

	const blogPermission =
		user && isEmployerRoute && queryGroupNumber
			? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.employer_settings_menu.blogs_sub.self
			: user
			? getPermissionsFromGroupOwner(user, 0)?.settings_menu.blogs_sub.self
			: null;

	const getPageCount = useCallback(async () => {
		if (limit) {
			const healthLinksCount = await api.healthLinks.countHealthLinks();
			const _pageCount = Math.ceil(healthLinksCount / limit);
			// console.log("Page Count", _pageCount);
			setPagination(
				Object.assign({}, pagination, {
					pageCount: _pageCount
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [limit]);

	// GET Health Links with Pagination
	const getFilterdHealthLinks = useCallback(
		async (limit = _limit, _page = null) => {
			const params = {
				page: 1,
				limit: 30000
			};

			try {
				// console.log(params);
				let response = await trackPromise(api.healthLinks.filterHealthLinks(params));
				// console.log("Response Blogs", response);

				if (queryGroupNumber && response) {
					response = response.filter((group: any) => group.group_number === queryGroupNumber);
					// console.log("filteredLinks 1", response, queryGroupNumber);
				}

				// console.log("filteredLinks", response);

				if (response) setLinks([...response]);
			} catch (err) {
				console.log("err", err);
			}
		},
		[_limit, queryGroupNumber]
	);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, params.api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("Action", "100%", true);
	};

	const deleteHealthLink = useCallback(
		async (_id: string) => {
			const _links = await trackPromise(api.healthLinks.deleteHealthLinkById(_id));
			if (_links) {
				setLinks(Object.assign([], [..._links]));
				setSnackbarAPICallProps(
					Object.assign({}, snackbarAPICallProps, {
						open: true,
						message: "Successfully deleted health link",
						severity: "success"
					})
				);
			}
		},
		[snackbarAPICallProps]
	);

	const handleDeleteClick = () => {
		const openDialog = true;
		const title = "Delete Confirmation";
		const content = "Are you sure you want to delete the health link ?";
		const actions = [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => setDeleteDialogProps(Object.assign({}, deleteDialogProps, { openDialog: false }))
			},
			{
				label: "Yes",
				name: "accept",
				callback: () => {
					const focusedCell = agGridRef.current.api.getFocusedCell();
					const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
					const {
						data: { _id }
					} = row;
					deleteHealthLink(_id);
					setDeleteDialogProps(Object.assign({}, deleteDialogProps, { openDialog: false }));
					//window.location.reload(); // This Reload is for re-rendering after delete
				}
			}
		];
		setDeleteDialogProps(
			Object.assign({}, deleteDialogProps, {
				openDialog,
				title,
				content,
				actions
			})
		);
	};

	const handleEditClick = useCallback(
		({
			_isEmployerRoute,
			_queryGroupNumber
		}: {
			_isEmployerRoute: boolean | null;
			_queryGroupNumber: number | null;
		}) => {
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const { data } = row;
			const pathname =
				_isEmployerRoute === true && _queryGroupNumber !== null
					? `/employer/settings/blog/edit?id=${data._id}&&new=false&&gn=${_queryGroupNumber}`
					: `/settings/blog/edit?id=${data._id}&&new=false`;
			navigate(pathname);
		},
		[navigate]
	);

	const handleAssignGroupClick = useCallback(
		({
			_isEmployerRoute,
			_queryGroupNumber
		}: {
			_isEmployerRoute: boolean | null;
			_queryGroupNumber: number | null;
		}) => {
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const { data } = row;
			const pathname =
				_isEmployerRoute === true && _queryGroupNumber !== null
					? `/employer/settings/blog/assign-groups?id=${data._id}&&gn=${_queryGroupNumber}`
					: `/settings/blog/assign-groups?id=${data._id}`;
			navigate(pathname);
		},
		[navigate]
	);

	const handleHealthLinkActionRenderer = ({
		_isEmployerRoute,
		_queryGroupNumber,
		blogPermission
	}: {
		_isEmployerRoute: boolean | null;
		_queryGroupNumber: number | null;
		blogPermission: any;
	}) => {
		if (!blogPermission) return null; // or fallback
		return (
			<div>
				{blogPermission.delete && (
					<Tooltip title="Delete" enterDelay={500} leaveDelay={200} arrow>
						<IconButton>
							<DeleteIcon onClick={handleDeleteClick} />
						</IconButton>
					</Tooltip>
				)}
				{blogPermission.update && (
					<Tooltip title="Edit" enterDelay={500} leaveDelay={200} arrow>
						<IconButton>
							<EditIcon
								onClick={() =>
									handleEditClick({
										_isEmployerRoute,
										_queryGroupNumber
									})
								}
							/>
						</IconButton>
					</Tooltip>
				)}
				{blogPermission.assign_location && (
					<Tooltip title="Assign Location" enterDelay={500} leaveDelay={200} arrow>
						<IconButton>
							<AssignmentTurnedInIcon
								onClick={() =>
									handleAssignGroupClick({
										_isEmployerRoute,
										_queryGroupNumber
									})
								}
							/>
						</IconButton>
					</Tooltip>
				)}
			</div>
		);
	};

	const handleOpenImageModal = () => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { image }
		} = row;
		setImageDialogProps(
			Object.assign({}, imageDialogProps, {
				openDialog: true,
				image: generateImageUrl(image)
			})
		);
	};

	const handleAddLinkClick = useCallback(() => {
		const pathname =
			isEmployerRoute === true && queryGroupNumber !== null
				? `/employer/settings/blog/edit?new=true&&gn=${queryGroupNumber}`
				: "/settings/blog/edit?new=true";
		navigate(pathname);
	}, [navigate, queryGroupNumber, isEmployerRoute]);

	const handleViewImageActionRender = ({ value }: { value: string }) => {
		return (
			<div>
				{value ? (
					<IconButton onClick={handleOpenImageModal}>
						<VisibilityIcon />
					</IconButton>
				) : (
					<div style={{ marginLeft: 15 }}>N/A</div>
				)}
			</div>
		);
	};

	// useEffect(() => {
	// 	setLimit(_limit);
	// 	getPageCount();
	// 	//getLinks();
	// 	setDashboardHeader(ADMIN_DASHBOARD_HEADER.blogs);
	// }, [_limit, getPageCount, setDashboardHeader]);

	// useEffect(() => {
	// 	if (limit) {
	// 		getFilterdHealthLinks();
	// 	}
	// }, [pagination, limit, getFilterdHealthLinks]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(links.length);
		setGridHeight(_gridHeight);
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.blogs);
		getFilterdHealthLinks();
	}, [getFilterdHealthLinks, links.length, setDashboardHeader]);

	const { currentPage, pageCount } = pagination;
	// eslint-disable-next-line arrow-parens
	// const groupNumber = links.filter((group) => group.group_number === queryGroupNumber);
	// console.log("link", links);

	return (
		<div className="health-links">
			<Suspense fallback={<div />}>
				<LazyCustomImageDialog dialogProps={imageDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<LazyCustomDialog dialogProps={deleteDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<LazySnackbarAPI snackbarProps={snackbarAPICallProps} />
			</Suspense>
			{blogPermission && blogPermission.create && (
				<div className="action-container">
					<Button className="button-green margin-10px" variant="contained" onClick={handleAddLinkClick}>
						<span className="button-label-with-icon">Add Blog</span>
						<span>
							<AddIcon className="button-icon" />
						</span>
					</Button>
				</div>
			)}
			<div className="data-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={links}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						animateRows
						rowDragManaged
						frameworkComponents={{
							handleHealthLinkActionRenderer: handleHealthLinkActionRenderer,
							handleViewImageActionRender: handleViewImageActionRender,
							schema: linkFilterSchema,
							setPayloadSchema: setLinkFilterSchema,
							setParentSchema: setLinks
						}}
						defaultColDef={{
							floatingFilter: true,
							resizable: true
						}}
						defaultColGroupDef={{ marryChildren: true }}
						rowSelection="multiple"
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["action"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="category"
							sortable
							rowDrag
							filter={true}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// floatingFilterComponent="customFloatingFilter"
							// filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="text"
							sortable
							filter={true}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// floatingFilterComponent="customFloatingFilter"
							// filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="URL"
							sortable
							filter={true}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// floatingFilterComponent="customFloatingFilter"
							// filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="image"
							sortable
							filter={false}
							cellRenderer="handleViewImageActionRender"
						></AgGridColumn>
						{blogPermission &&
							(blogPermission.assign_location || blogPermission.update || blogPermission.delete) && (
								<AgGridColumn
									field="Action"
									sortable
									filter={false}
									cellRenderer="handleHealthLinkActionRenderer"
									cellRendererParams={{
										_isEmployerRoute: isEmployerRoute,
										_queryGroupNumber: queryGroupNumber,
										blogPermission: blogPermission
									}}
								></AgGridColumn>
							)}
					</AgGridReact>
				</div>
			</div>
			{/* <div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div> */}
		</div>
	);
};

export default HealthLinks;
